import { defineMessages } from 'react-intl';

export default defineMessages({
  shopdetails_section_text: {
    id: 'app.conversion.containers.ShelvesLayout.ShelvesSections.text',
    defaultMessage:
      'Para ver los productos de esta sección es necesario que seas mayor de edad.',
  },
  shopdetails_section_link: {
    id: 'app.conversion.containers.ShelvesLayout.ShelvesSections.link',
    defaultMessage: 'Validar edad',
  },
});
